import setAgentPreferences from 'actions/agent_preferences/set_agent_preferences';
import { SidePanelType } from 'models/side_panel';

export default class OpenTeamAssistPanel {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, conversationId, compositionId }) {
    const sidePanel = this.context.stores.sidePanel.get();
    if (!sidePanel.isShowing(SidePanelType.AI_ASSIST)) {
      sidePanel.show(SidePanelType.AI_ASSIST);
      this.context.stores.sidePanel.set(sidePanel);

      const preferences = this.context.stores.agentPreferences.get();
      preferences.setSidePanel(sidePanel);
      setAgentPreferences(this.context, preferences);
    }

    this.context.analytics.track('Team Assist Panel Opened', { customerId, conversationId, compositionId });
  }
}
